import React from "react";

import { getZendeskTicketUrl } from "../../../../../../../constants/endpoints";
import { getDateFormat } from "../../../../../../../common/date-format";
import { API_NAMES } from "../../EVisa/constants/apiNames";

export const columns = {
  lastName: {
    label: "Last name",
  },
  firstName: {
    label: "First name",
  },
  userEmail: {
    label: "Email",
  },
  birthCountry: {
    label: "Country",
  },
  _id: {
    label: "ID",
    value: (applicant) => (
      <a
        href={`${API_NAMES.IND}/applicant/${applicant._id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {applicant._id}
      </a>
    ),
  },
  createdAt: {
    label: "Created at",
    value: (applicant) => getDateFormat(applicant.createdAt),
  },
  paymentStatus: {
    label: "Payment status",
  },
  status: {
    label: "Status",
  },
  zendeskId: {
    label: "Zendesk ID",
    value: (applicant) => (
      <a
        href={getZendeskTicketUrl(applicant.zendeskId, applicant.zendeskInstance)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {applicant.zendeskId}
      </a>
    ),
  },
};
